import React from "react"
import { Grid2, IconButton } from "@mui/material"
import {
	Close as CloseIcon
} from "@mui/icons-material"

import { CloseIconButtonProps } from "@/components/Dialog/protocols"

export const CloseIconButton = ({
	onClick
}: CloseIconButtonProps) => {
	return (
		<Grid2
			size={1}
			container
			justifyContent="flex-end"
			alignItems="flex-start"
			height="100%"
		>
			<IconButton
				onClick={onClick}
				size="small"
			>
				<CloseIcon />
			</IconButton>
		</Grid2>
	)
}